import {Container, Row} from "react-bootstrap";
import {useContext, useEffect} from "react";
import {AppContext} from "../lib/AppContext";
import {useNavigate} from "react-router-dom";
import {logout} from "./common/api/WebApi";
import DashboardLayout from "./LayoutContainers/DashboardLayout";
import MDBox from "../components/MDBox";
import LoginForm from "./common/LoginForm";
import Footer from "./Footer";

export default function Init(props) {
  const [context, setContext] = useContext(AppContext);
  const navigate = useNavigate();

  const logoutFn = async () => {
    let path = '/';
    let resp = await logout();
    if (resp) {
      window.location.href = path;
    }
  }

  const handleLogin = () => {
  }

  useEffect(() => {
    logoutFn();
  }, []);

  return (
    <>
      <DashboardLayout>
        <MDBox py={3}>
          <MDBox mb={3}>
            <Row>
              <Container className="dashboard">
                <LoginForm handleLogin={handleLogin}/>
              </Container>
            </Row>
          </MDBox>
        </MDBox>

        <Footer mt={5}/>

      </DashboardLayout>
    </>
  );
}